import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Dropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../Styles/yellowcalfcss/Bills.css';

const mockBills = [
  { id: 1, billNumber: 'WWXXZZ', supplier: 'new supplier', billDate: '2024-03-15', dueDate: '2024-04-15', totalAmount: 120, status: 'Pending' },
  { id: 2, billNumber: 'DJFHD', supplier: 'new supplier', billDate: '2024-03-10', dueDate: '2024-04-10', totalAmount: 66, status: 'Pending' },
  { id: 3, billNumber: 'DFDFD', supplier: 'new supplier', billDate: '2024-3-12', dueDate: '2024-4-12', totalAmount: 0, status: 'Pending' },
  { id: 4, billNumber: 'DFDFD', supplier: 'new supplier', billDate: '2024-3-08', dueDate: '2024-4-08', totalAmount: 450, status: 'Pending' },
  { id: 5, billNumber: 'WWDJDHF', supplier: 'new supplier', billDate: '2024-3-20', dueDate: '2024-4-20', totalAmount: 140, status: 'Pending' },
  { id: 6, billNumber: 'DFDFDD', supplier: 'new supplier', billDate: '2024-3-18', dueDate: '2024-4-18', totalAmount: 1, status: 'Pending' },
  { id: 7, billNumber: 'DFDFFD', supplier: 'new supplier', billDate: '2024-3-14', dueDate: '2024-4-14', totalAmount: 650, status: 'Pending' },
  { id: 8, billNumber: 'EFGF', supplier: 'new supplier', billDate: '2024-3-22', dueDate: '2024-4-22', totalAmount: 425, status: 'Pending' },
  { id: 9, billNumber: 'DGJDJ', supplier: 'new supplier', billDate: '2024-3-16', dueDate: '2024-4-16', totalAmount: 2800, status: 'Pending' },
  { id: 10, billNumber: 'DFKJG', supplier: 'new supplier', billDate: '2024-3-11', dueDate: '2024-4-11', totalAmount: 1950, status: 'Pending' },
  { id: 11, billNumber: 'DFKDJ', supplier: 'new supplier', billDate: '2024-3-19', dueDate: '2024-4-19', totalAmount: 725, status: 'Pending' },
  { id: 12, billNumber: 'KFKF', supplier: 'new supplier', billDate: '2024-3-17', dueDate: '2024-4-17', totalAmount: 580, status: 'Pending' },
  { id: 13, billNumber: 'DFDFDF', supplier: 'new supplier', billDate: '2024-3-21', dueDate: '2024-4-21', totalAmount: 315, status: 'Pending' },
  { id: 14, billNumber: 'DOSJD', supplier: 'new supplier', billDate: '2024-3-13', dueDate: '2024-4-13', totalAmount: 975, status: 'Pending' },
  { id: 15, billNumber: 'JHDJH', supplier: 'new supplier', billDate: '2024-3-09', dueDate: '2024-4-09', totalAmount: 0, status: 'Pending' },
  { id: 16, billNumber: 'JHFJ', supplier: 'new supplier', billDate: '2024-3-23', dueDate: '2024-4-23', totalAmount: 850, status: 'Pending' },
  { id: 17, billNumber: 'IJKDF', supplier: 'new supplier', billDate: '2024-3-07', dueDate: '2024-4-07', totalAmount: 1480.5, status: 'Pending' },
  { id: 18, billNumber: 'JFHJKD', supplier: 'new supplier', billDate: '2024-3-25', dueDate: '2024-4-25', totalAmount: 0, status: 'Pending' },
  { id: 19, billNumber: 'DFDF', supplier: 'new supplier', billDate: '2024-3-06', dueDate: '2024-4-06', totalAmount: 750, status: 'Pending' },
  { id: 20, billNumber: 'DJHDJ', supplier: 'new supplier', billDate: '2024-3-24', dueDate: '2024-4-24', totalAmount: 0, status: 'Pending' },
  { id: 21, billNumber: 'HCGD', supplier: 'new supplier', billDate: '2024-3-26', dueDate: '2024-4-26', totalAmount: 0, status: 'Pending' },
  { id: 22, billNumber: 'JHDJ', supplier: 'new supplier', billDate: '2024-3-27', dueDate: '2024-4-27', totalAmount: 12, status: 'Pending' },
  { id: 23, billNumber: 'JHJH', supplier: 'new supplier', billDate: '2024-3-28', dueDate: '2024-4-28', totalAmount: 210, status: 'Pending' },
  { id: 24, billNumber: 'JCHDJK', supplier: 'new supplier', billDate: '2024-3-29', dueDate: '2024-4-29', totalAmount: 0, status: 'Pending' },
  { id: 25, billNumber: 'JCHD', supplier: 'new supplier', billDate: '2024-3-30', dueDate: '2024-4-30', totalAmount: 675, status: 'Pending' },
  { id: 26, billNumber: 'DJKDH', supplier: 'new supplier', billDate: '2024-3-31', dueDate: '2024-5-01', totalAmount: 13, status: 'Pending' },
  { id: 27, billNumber: 'JHCJ', supplier: 'new supplier', billDate: '2024-4-01', dueDate: '2024-5-01', totalAmount: 8, status: 'Pending' },
  { id: 28, billNumber: 'FDJF', supplier: 'new supplier', billDate: '2024-4-02', dueDate: '2024-5-02', totalAmount: 55, status: 'Pending' },
  { id: 29, billNumber: 'JDFHDJ', supplier: 'new supplier', billDate: '2024-4-03', dueDate: '2024-5-03', totalAmount: 10, status: 'Pending' },
  { id: 30, billNumber: 'DJJD', supplier: 'new supplier', billDate: '2024-4-04', dueDate: '2024-5-04', totalAmount: 18, status: 'Pending' },
  { id: 31, billNumber: 'SDFESD', supplier: 'new supplier', billDate: '2024-4-05', dueDate: '2024-5-05', totalAmount: 47, status: 'Pending' }
];

const Eye = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

const Edit = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 20h9"></path>
    <path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4 12.5-12.5z"></path>
  </svg>
);

const Trash2 = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"></path>
    <path d="M10 11v6"></path>
    <path d="M14 11v6"></path>
    <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"></path>
  </svg>
);

const Download = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </svg>
);

export default function BillList() {
  const [bills, setBills] = useState(mockBills);
  const [filters, setFilters] = useState({ billNumber: '', billDate: '' });
  const [currentPage, setCurrentPage] = useState(1);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const itemsPerPage = 20;

  const handleDeleteBill = (id) => {
    if (window.confirm("Are you sure you want to delete this bill?")) {
      setBills(prev => prev.filter(bill => bill.id !== id));
    }
  };

  const handleFilterChange = (column, value) => {
    setFilters(prev => ({ ...prev, [column]: value }));
    setCurrentPage(1);
  };

  const filteredBills = bills.filter(bill =>
    bill.billNumber.toLowerCase().includes(filters.billNumber.toLowerCase()) &&       
    bill.billDate.includes(filters.billDate)
  );

  const totalItems = filteredBills.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);
  const paginatedBills = filteredBills.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5;
    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 5; i++) pageNumbers.push(i);
      } else if (currentPage >= totalPages - 2) {
        for (let i = totalPages - 4; i <= totalPages; i++) pageNumbers.push(i);
      } else {
        for (let i = currentPage - 2; i <= currentPage + 2; i++) pageNumbers.push(i);
      }
    }
    return pageNumbers;
  };

  const navigate = (path) => {
    window.location.href = path;
  };

  return (
    <div className="bill-list-wrapper">
      <Container fluid className="bill-list-container">
        <div className="header-card">
          <div className="header-content">
            <h4>Bills</h4>
            <div className="button-group">
              <Button className="action-btn" onClick={() => navigate("/accountant/CreateBill")}>  
                Create Bill
              </Button>
              <Button className="action-btn" onClick={() => navigate("/accountant/PaidBills")}>
                Paid Bill
              </Button>
              <Button className="action-btn" onClick={() => navigate("/accountant/PayBill")}>
                Pay Bill
              </Button>
              <Button className="action-btn" onClick={() => navigate("/accountant/Suppliers")}>
                Suppliers
              </Button>
              <Dropdown show={dropdownOpen} onToggle={setDropdownOpen}>
                <Dropdown.Toggle className="action-btn export-btn">
                  <Download /> Export
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item href="#">Export to CSV</Dropdown.Item>
                  <Dropdown.Item href="#">Export to PDF</Dropdown.Item>
                  <Dropdown.Item href="#">Export to Excel</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>

        <div className="filter-section">
          <Form.Control
            type="text"
            placeholder="Filter by Bill Number..."
            value={filters.billNumber}
            onChange={e => handleFilterChange('billNumber', e.target.value)}
            className="filter-input"
          />
          <Form.Control
            type="text"
            placeholder="Filter by Date..."
            value={filters.billDate}
            onChange={e => handleFilterChange('billDate', e.target.value)}
            className="filter-input"
          />
        </div>

        <div className="table-header">
          <div className="table-grid">
            <div className="col-sr">Sr No</div>
            <div className="col-bill">Bill Number</div>
            <div className="col-supplier">Supplier</div>
            <div className="col-date">Bill Date</div>
            <div className="col-date">Due Date</div>
            <div className="col-amount">Total Amount</div>
            <div className="col-status">Status</div>
            <div className="col-actions">Actions</div>
          </div>
        </div>

        <div className="table-rows">
          {paginatedBills.length === 0 && (
            <div className="table-row empty-row">
              No bills found.
            </div>
          )}
          {paginatedBills.map((b, index) => (
            <div key={b.id} className="table-row">
              <div className="table-grid">
                <div className="col-sr">{startItem + index}</div>
                <div className="col-bill">{b.billNumber}</div>
                <div className="col-supplier">{b.supplier}</div>
                <div className="col-date">{b.billDate}</div>
                <div className="col-date">{b.dueDate}</div>
                <div className="col-amount">{b.totalAmount}</div>
                <div className="col-status">{b.status}</div>
                <div className="col-actions">
                  <Button className="icon-btn" onClick={() => navigate(`/accountant/ViewBill/`)} title="View">
                    <Eye />
                  </Button>
                  <Button className="icon-btn" onClick={() => navigate(`/accountant/EditBill/`)} title="Edit">
                    <Edit />
                  </Button>
                  <Button className="icon-btn" onClick={() => handleDeleteBill(b.id)} title="Delete">
                    <Trash2 />
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="pagination-card">
          <div className="pagination-info">Showing {startItem} to {endItem} of {totalItems} entries</div>
          <div className="pagination-controls">
            <Button 
              className="page-btn" 
              disabled={currentPage === 1} 
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
            >
              Previous
            </Button>
            {getPageNumbers().map(number => (
              <Button
                key={number}
                className={currentPage === number ? "page-btn active" : "page-btn"}
                onClick={() => setCurrentPage(number)}
              >
                {number}
              </Button>
            ))}                   
            <Button 
              className="page-btn" 
              disabled={currentPage === totalPages || totalPages === 0} 
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
            >
              Next
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
}
